<div class="context-box">
    <div class="progress"><mat-progress-bar mode="indeterminate" *ngIf="(loading$ | async)"></mat-progress-bar></div>

    <div class="title">Kalender</div>
    <div class="menu">
        <mat-button-toggle-group>
            <mat-button-toggle [checked]="(mode$ | async) == 'list'" (click)="setMode('list')" title="Als Liste anzeigen">
                <span class="iconify inline" data-icon="tabler:list-check"></span>
            </mat-button-toggle>
            <mat-button-toggle [checked]="(mode$ | async) == 'calendar'" (click)="setMode('calendar')" title="Im Kalender anzeigen">
                <span class="iconify inline" data-icon="tabler:calendar-month"></span>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <app-mini-calendar *ngIf="(mode$ | async) == 'calendar'" (dateChanged)="dateChanged($event)" [currentMonthEvents]="(selectedMonthEvents$ | async)" (monthChanged)="monthChanged($event)">
        <div *ngIf="(selectedCalendarDateEvents$ | async) != null">
            <div class="text-sm px-3 bg-blue-400 text-white rounded-lg inline-block font-medium mb-2 mt-3">{{ (selectedCalendarDateEvents$ | async)?.length }} Termine</div>
            <div *ngIf="(selectedCalendarDateEvents$ | async)?.length == 0">
                Keine Termine an diesem Tag
            </div>
            <app-event (deleted)="removeEvent(event)" [event]="event" *ngFor="let event of (selectedCalendarDateEvents$ | async)"></app-event>
        </div>
    </app-mini-calendar>

    <div *ngIf="(mode$ | async) == 'list'" style="max-height:40vh;overflow: auto;" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
        <app-event (deleted)="removeEvent(event)" [cooperation]="(cooperation$ | async)" [event]="event" *ngFor="let event of (eventList$ | async)"></app-event>
    </div>

    <button *ngIf="(cooperation$ | async)" (click)="addEvent()" mat-flat-button color="primary" class="w-full mt-2">
        Termin hinzufügen
    </button>
    <button *ngIf="!(cooperation$ | async)" (click)="addCooperation()" mat-flat-button color="primary" class="w-full mt-2">
        Kooperation hinzufügen
    </button>
</div>
